import * as React from 'react';
import { Link } from 'react-router-dom';
import BulletedMsg from '../../../../layout/BulletedMsg';
import { Str } from '../../../../localization/translationKeys';
import { Routes } from '../../../../navigation/routes';
import { css } from '@emotion/core';
import { COLORS } from '../../../../globalStyle/colors';
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons/faCircle';


const styles = {
  root:       css`
    border: 1px solid ${COLORS.LIGHTER_GREY};
    border-radius: 8px;
    
    & > * {
      border-bottom: 1px solid ${COLORS.LIGHTER_GREY};
    }
    
    & > *:last-child {
      border-bottom: none;
    }
  `,
  link:       css`
    display: block;
    padding: 18px 15px;
    text-decoration: none;
    
    &:hover {
      cursor: pointer;
    }
  `,
  stepLink:   css`
    color: ${COLORS.MEDIUM_GREY};
    
    &:hover {
      background-color: ${COLORS.LIGHTEST_GREY};
    }
  `,
  activeLink: css`
    color: ${COLORS.DARK_GREY};
    background-color: ${COLORS.LIGHTER_GREY};
    
    &:hover {
      background-color: ${COLORS.LIGHTEST_GREY};
    }
  `,
  iconGreen:  css`
    font-size: 15px;
    color: ${COLORS.GREEN};
  `,
};


type Props = {
  routes: Routes;
  className?: string;
};


const activeLink = (route: string) => (
  window.location.pathname.endsWith(route)
);


/**
 * CollaboratorProjectSteps: a component that displays menu items for collaborators (currently just a link back to the
 * dev plan)
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CollaboratorProjectSteps: React.FC<Props> = ({ routes, className }) => (
  <div css={styles.root} className={className}>
    <Link
      to={routes.CollaboratorDevPlan}
      css={[
        styles.link,
        activeLink(routes.CollaboratorDevPlan) ? styles.activeLink : styles.stepLink,
      ]}
    >
      <BulletedMsg
        icon={faCircleSolid}
        msg={Str.DevPlan}
        iconStyle={styles.iconGreen}
        spacePx={14}
      />
    </Link>
  </div>
);

export default CollaboratorProjectSteps;
